<template>
	<div>
		<!-- Submenu -->
		<product-detail-submenu />

		<core-layout-content medium>
			<!-- Language selector -->
			<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
				<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
				<core-select-locale
					class="xs-12"
					size="xsmall"
					v-model="selectedLocale"
				/>
			</div>
			<template v-if="!isLoading">
				<!-- Product Item -->
				<products-list-item
					:name="product.name"
					:plan="product.plan"
					:version="product.version"
					:type="product.type"
					:insurerName="product.insurerName"
					:insurerLogoUrl="product.insurerLogoUrl"
					:selectedLocale="selectedLocale"
					@updated="getProduct"
				>
					<template slot="action">
						<!-- <j-button>{{ $t("edit") }}</j-button> -->
					</template>
				</products-list-item>

				<!-- If product doesn't exist -->
				<j-card
					v-if="!isLoading && product.length === 0"
					class="bg5 ta2 p2 cError fw7"
				>
					{{ $t("errors.product_doesnt_exist") }}
				</j-card>
			</template>
		</core-layout-content>
	</div>
</template>

<script>
import ProductDetailSubmenu from "../components/ProductDetailSubmenu"
import ProductsListItem from "../components/ProductsListItem"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		ProductDetailSubmenu,
		ProductsListItem,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreSelectLocale
	},

	props: {
		plan: { type: String, required: true },
		type: { type: String, required: true },
		version: {
			validator: val => typeof val === "string" || val === null,
			required: true,
			default: null
		}
	},

	data: () => ({
		isLoading: false,
		selectedLocale: i18n.locale,
		list: []
	}),

	computed: {
		/**
		 * What we display
		 */
		product() {
			const list = this.list.map(item => ({
				name: item.name,
				plan: get(item, "productId.plan"),
				type: get(item, "productId.type"),
				version: get(item, "productId.version"),
				insurerName: get(item, "insurer.name"),
				insurerLogoUrl: get(item, "insurer.logoUrls.typeC")
			}))

			return list.length > 0 ? list[0] : {}
		}
	},

	methods: {
		async getProduct() {
			const { plan, version, type } = this

			this.isLoading = true
			const res = await api.readAllProducts(
				{
					where: { productId: { plan, version, type } }
				},
				this.selectedLocale
			)
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.list = res.data.products_2.list
		}
	},

	created() {
		// Check if we are receiving all props
		// If not, redirect to products listing
		if (
			typeof this.plan === "undefined" ||
			typeof this.type === "undefined" ||
			typeof this.version === "undefined"
		) {
			this.$router.push({ name: "ProductsList" })
			return
		}

		// Fetch product info
		this.getProduct()
	},

	watch: {
		selectedLocale: {
			handler(o, n) {
				if (o && n) {
					this.getProduct()
				}
			}
		}
	}
}
</script>
